import { useCallback, useState } from "react";

export default function useBooleanState(
  initialState: boolean
): [boolean, () => void, () => void, (value: boolean) => void] {
  const [value, setValue] = useState(initialState);

  return [
    value,
    useCallback(() => setValue(true), []),
    useCallback(() => setValue(false), []),
    setValue,
  ];
}
